import { useState } from "react";
import { getRegistrationNetworkConfigPreview } from "../api/user";

export function useRegistrationNetworkConfigPreviewHooks() {
  let [data, setData] = useState({});
  let [success, setSuccess] = useState(null);
  let [fetched, setFetched] = useState(false);
  let [error, setError] = useState(null);
  let [loading, setLoading] = useState(false);

  const fetchNetworkConfigPreview = async ({ registration_id, olt_id }) => {
    setData({});
    setError("");
    setLoading(true);
    setSuccess(null);
    setFetched(false);
    try {
      let response = await getRegistrationNetworkConfigPreview({ registration_id, olt_id });
      setData(response.data.data);
      setFetched(true);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setError(data.message);
      } else {
        setError("Something Error Happened");
      }
    }

    setLoading(false);
  };

  return {
    data,
    fetched,
    success,
    error,
    loading,
    fetchNetworkConfigPreview,
  };
}
